import { Application } from '../../../../../types/api';
import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { powerSoldToSingleUserCondition } from '../../components/loan_application/utils/helpers';
import { LoanApplication, type PROJECT_TYPE } from '../../modules/loan';
import { ValidationSchema } from '../interfaces';
import FileNameValidationSchema from '../FileNameValidationSchema';
import { Validation } from '../Validation';

const { ppaLeaseFinancialProjections } =
  loanFormModel.formField.solarSystemDocuments;
const { projectType, systemPowerSingleOrMultipleUsers } =
  loanFormModel.formField;

export class PpaLeaseFinancialProjectionsValidation
  implements ValidationSchema
{
  public name = ppaLeaseFinancialProjections.name;
  public label = '';
  public dependsOn: string[] = [
    projectType.name,
    systemPowerSingleOrMultipleUsers.name,
  ];
  public type = 'array';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(
    projectType: string,
    singleOrMultipleUsers: Application['system_power_single_or_multiple_users'],
    schema
  ) {
    if (!projectType || !LoanApplication.isSolar(projectType as PROJECT_TYPE))
      return FileNameValidationSchema(ppaLeaseFinancialProjections.name, false);
    if (powerSoldToSingleUserCondition(singleOrMultipleUsers))
      return FileNameValidationSchema(ppaLeaseFinancialProjections.name, true);
    return FileNameValidationSchema(ppaLeaseFinancialProjections.name, false);
  }
}
export default new Validation(new PpaLeaseFinancialProjectionsValidation());
